<template>
  <InputTableContainer
    :loading="$apollo.loading"
    :headers="headers"
    :data="data"
    :actions="actions"
    :sortBy="sortBy"
    :sortDesc="sortDesc"
    type="rejectedStop"
  >
    <template v-slot:toolbar-right>
      <RejectedStopCreateDropdown />
    </template>
  </InputTableContainer>
</template>

<script>
import { get } from 'vuex-pathify'
import InputTableContainer from '@/components/InputTableContainer'
import RejectedStopCreateDropdown from './RejectedStopCreateDropdown'
import RejectedStopEditModal from './RejectedStopEditModal'
import RejectedStopDeleteModal from './RejectedStopDeleteModal'

export default {
  name: 'RejectedStopContainer',

  components: {
    InputTableContainer,
    RejectedStopCreateDropdown
  },

  data: () => ({
    actions: [
      {
        title: 'Redigera',
        icon: 'mdi-pencil',
        component: RejectedStopEditModal,
        type: 'edit'
      },
      {
        title: 'Ta bort',
        icon: 'mdi-delete',
        component: RejectedStopDeleteModal,
        type: 'delete'
      }
    ],
    sortDesc: false,
    sortBy: ['_location_time'],
    headers: [
      {
        text: 'Typ',
        value: 'type'
      },
      {
        text: 'Tågnr.',
        value: 'train_number'
      },
      {
        text: 'Platser',
        value: '_location_places'
      },
      {
        text: '',
        value: 'actions',
        sortable: false,
        filterable: false,
        align: 'right'
      }
    ]
  }),

  computed: {
    trainDeviations: get('trainDeviation/data'),
    stops: get('event/stops'),

    data() {
      const findLocationName = signature => {
        const location = this.stops.find(
          x => x.short_name === signature.toUpperCase()
        )
        return location ? location.stop_name : signature.toUpperCase()
      }
      return Object.values(this.trainDeviations)
        .filter(x => x.deviation_type === 'CANCELED_STOP')
        .map(x => ({
          ...x,
          _location_places:
            x.places
              ?.split(', ')
              .map(x => findLocationName(x))
              .join(', ') || []
        }))
    }
  },

  beforeDestroy() {
    this.$store.set('rejectedStop/data', {})
  }
}
</script>
